import { jsPDF } from 'jspdf';
import type { StatementExportData } from '../models/FinancialStatement';
import type { FinancialTransaction } from '../models/FinancialTransaction';
import type { AccountType } from '../models/FinancialAccount';

// KIV Logo as base64
const KIV_LOGO_BASE64 = '/9j/4Q/+RXhpZgAATU0AKgAAAAgABgESAAMAAAABAAEAAAEaAAUAAAABAAAAVgEbAAUAAAABAAAAXgEoAAMAAAABAAIAAAITAAMAAAABAAEAAIdpAAQAAAABAAAAZgAAAAAAAABIAAAAAQAAAEgAAAABAAeQAAAHAAAABDAyMjGRAQAHAAAABAECAwCgAAAHAAAABDAxMDCgAQADAAAAAQABAACgAgAEAAAAAQAAAYugAwAEAAAAAQAAAECkBgADAAAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/9sAhAABAQEBAQECAQECAwICAgMEAwMDAwQGBAQEBAQGBwYGBgYGBgcHBwcHBwcHCAgICAgICQkJCQkLCwsLCwsLCwsLAQICAgMDAwUDAwULCAYICwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwv/3QAEABn/wAARCABAAYsDASIAAhEBAxEB/8QBogAAAQUBAQEBAQEAAAAAAAAAAAECAwQFBgcICQoLEAACAQMDAgQDBQUEBAAAAX0BAgMABBEFEiExQQYTUWEHInEUMoGRoQgjQrHBFVLR8CQzYnKCCQoWFxgZGiUmJygpKjQ1Njc4OTpDREVGR0hJSlNUVVZXWFlaY2RlZmdoaWpzdHV2d3h5eoOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4eLj5OXm5+jp6vHy8/T19vf4+foBAAMBAQEBAQEBAQEAAAAAAAABAgMEBQYHCAkKCxEAAgECBAQDBAcFBAQAAQJ3AAECAxEEBSExBhJBUQdhcRMiMoEIFEKRobHBCSMzUvAVYnLRChYkNOEl8RcYGRomJygpKjU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6goOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4uPk5ebn6Onq8vP09fb3+Pn6/9oADAMBAAIRAxEAPwD+Hb/hqT9pf/ooXiT/AMGlz/8AHK+if2RP2lf2i9T/AGqPhzp+oePfEU0E3iTTEeN9TuSrKZ0BBHmdPavz/r6U/Y1/5O0+Gn/YzaX/AOlCUAf7rNhk2MJP9xf5VbqpYf8AHjD/ANc1/lT7q6trG2kvb2RYYYVLu7naqqvUk9AAKEuiE2krsbe3tpp1pLf38qwQQKXkkchVVVHJJ6AAV/NN/wAFFP8Agohe/Fq8uvgr8GLpoPDMDGO9vIzta+Zeqj0iHp/F9OKs/wDBRX/gohc/FS8uvgr8FbtovDcDGO9vYztN66/wqf8AnkP/AB6vxpr+ifDnw6WHUM0zSHv7wg/s9m137Lp67fxt40eM31v2mQZDU/dbVKi+1/dj/d7v7Wy03K/W/wD4J4/8E8L746ajb/F/4xWz2/g61cNbWrja2ouv8oR3P8XQcVH/AME9f+Cemo/HTU7f4sfFq3e28JWrhoLdhta+Ze3tH6nv0r+nfTdN0/RtPh0nSYUtra2RY4oo1CoiKMAADgACtfEXxF+qKWV5XL97tKS+z5L+95/Z9dufwY8GHj3Tz3Paf7ha06b+32lJfydl9r/Dv/N//wAHTev698Mf+CQWrXfw3vrjQJbTXdJhhfTpWtWjjAlGxTGVIXAHHTiv8sz/AIak/aX/AOiheJP/AAaXP/xyv9R3/g7U/wCUPWvf9jFpX8pa/wAmuv5xbvqz+0UklZbH9ln/AAaBfGj4wfEL/gpbrujePPFWr61Zp4QvZFgvr2a4jDiWIA7XYjI+lf24/wDBQ39pnxZ+yx8Wfhh4/wBBZptPm/tCDU7IHC3NtmDjHTcnVD2PsTX8If8AwZpf8pP9f/7E2+/9Gw1/ZD/wXA+58O/+4l/7Qr7Tw9wdHF57Qw2IjzQkppry9nL+vI/M/GHMsTl/CmKxuDny1abpOLXRqrD+rbNabH7e/Db4i+E/ix4I074geCLpbvTdSiWWJ19+x9COhHau5r+Vf/gmz+2tcfs++N0+Gnju5Y+EtalAyx4tLhuA49Fbo351/VBa3VtfW0d5ZuskUqhkZeQVPQisOMuFK2RY50Ja0nrCXddvVbM6vDXj/DcVZVHFQtGtGyqQ/ll3X917r7uhYooor5I/QwooqlqOo2OkWE2qanKsFvboZJJHOFVVHJP0ppX0Qm1FXexwHxf+LXgv4H/DzUviX49uRbadpsRdv78jfwxoO7McACvgD/gm9+0N40/aa1f4jfEzxg5RZdSgisrQNmO1tlj+SNe3HVj3bJr8dv8Agof+2ffftNfEI+FvCszJ4Q0KRltUHAuZRwZmH6J6D61+hf8AwRH/AORA8b/9hGD/ANFCv2DE8ErKeE6+Oxcf9onyafyR5lp6vr93Q/nHA+KD4g8QcLlWXy/2Oj7TVf8ALyahJc3+FbR+/tb9yaKK/LP9uP8A4LJfsH/8E7PiDpvww/ak8S3Gjavqtob22iitWmDQg7c5BGOe1fjx/R5+plFeK/s6ftAfDL9qj4J+Hv2gvg3dtf8AhjxPbm60+4dPLZ41do8lT0+ZSK+Xf26/+CpX7Ff/AAThg0Q/tWeK10S48Ql/sNrFH59w6RY3PsXkIOmT36UAfoZRX58/sLf8FOP2U/8Ago1Zaxq37LF/f6xYaEVS6u57Nre3Dt0RXbhmHcDpXxR8Z/8Ag5B/4JU/AL4q698F/iX4yvbTXvDV29jfQrYu6pNH1AIPIoA/d2iv51P+Ip//AII4/wDQ9X//AILn/wAa+9P2Yv8Agrp+xV+2D8EfG/7QXwC1m91nw58PQx1h1s2WWMJGJTsjzlsIc8UAfpvRX4ofs3/8HBv/AAS9/aq+NOi/s/8Awj8byzeJtfm+z2UF1atbrJL2TcxwCewr9r6ACivyV/bU/wCC3P8AwTu/4J//ABgT4EftJ+MH03xM1jFqD2ltbtcGKGcsI95U/KzbSQP7uD3r7q/Zm/aY+Ff7WvwQ0f8AaG+D0883hfXYmnsri7hNu0kSkjftbopxkHuOaAPoCivw/wD2sv8Ag4h/4JX/ALHvi66+H3j7x8NZ1yyYpcWehQ/bTC4/hZlIUH6E1wn7OP8Awcxf8ElP2kPFtr4G0nx3L4a1G9cRQDXrY2cTuegEmWUZ98CgD9+6K5/UvFGhaX4VuPGk1wkmmW1q1608RDoYETfuUjgjaMjHWvwEvP8Ag6N/4I72F3LY3Pjy8WSB2jYf2e/BU4PegD+huiv52/8AiKY/4I4f9D7ef+C9/wDGvQPhP/wclf8ABJ/41fE/w78Hvh/42u7nXfFOo2ulafC1i6h7m7kWKJSc8AswGe1AH7yUUV+Wf7ZX/BZ//gnL+whqLeHfj78RLKHW0+9pWn/6ZeL9UThfoSDQB+plFfzU+Bf+DsL/AIJA+M/EC6DeeJdY0VXYItzfacyQDPGSyscD8K/fL4GftCfBL9pfwJb/ABL+AvifT/FWh3IBS60+YSqM9mA5U+zAGgD2SivPPiz8UPB/wS+GWu/F34gTta6H4bsZtQvpVXeUggXc5CjrgDpX5Jfsy/8ABwf/AMEu/wBrX4zaR8BPhB44kk8R66xjsYry2NvHLIBwgdjjcewoA/bCiivzU/b1/wCCtP7FP/BNbWvDfh/9rDX7jRbnxXDcz6csFsZw6WhjWTOCMYMi0AfpXRXzJ+yh+158EP20/gHpv7SvwC1CTUvCeq/aBb3EsRiY/ZXaOT5D0wyEV+RPiT/g5/8A+CQnhPxFf+Fta8b30d5ptxJazqNPcgSRMVYdexFAH9CNFfzqf8RT/wDwRx/6Hq//APBc/wDjX0n4B/4L2/8ABNr4l+ErTxt4U8V3cun3u/ynayZSfLcxnjPqpoA//9D/AD/6+lP2Nf8Ak7T4af8AYzaX/wClCV8119IfsdzQ237V3w3uLh1jjj8SaYzMxwqqJ0ySewAoA/3VYrq2sdIS8vHWKKKIM7scKqgdTX83/wDwUX/4KJ3HxPubv4H/AATu2i8PQsY9Qv4jg3jL1RCP+WQ7/wB76Un/AAUL/wCCiNz8REm+BfwQvDHoMKiLUNQhODdkDBjjI/5Z+p/i+lfjHX9D+HHh17DkzXNIe/vCD+z2k137Lp67fxx40eM/1n2mQZDU/d7VKi+13hB/y9312Wm5X6x/8E9v+CfOp/HjVIPir8U4HtvCVq4aGJhta+dew/6Zjuarf8E8/wDgn3qf7QWqQfFb4o272vgy0fMMbDa2oOh+6v8A0yBGGbv0HfH9Qmj6Ppfh/S7fRNEt47W0tUWKGGJQqIijAAA6AV0+I3iIsGpZXlkv3u0pL7Hkv73/AKT67cXgv4NPMXTz3PKdsOtadN/b7Sa/k7L7X+HddI0nTNB0yDRdGgS1tLVBHFFGNqIi8AACtGiiv5wbbd2f2nGKilGKskfzN/8AB2p/yh617/sYtK/lLX+TXX+sp/wdqf8AKHrXv+xi0r+Utf5NdIZ/XD/wZpf8pP8AX/8AsTb7/wBGw1/ZL/wW/hmNt8PLgIfLDaipbHygkQYGfwr+Nr/gzS/5Sf6//wBibff+jYa/0o/2i/gF4L/aR+Ft/wDDPxnGNs677W4Ay9tcKPkkX6dCO44r6Xg/OaWVZxh8dWV4Rbvbs043+V72Ph/Efhqvn/DmLyrDNKpNLlvteMlJLyvy28j+IOv6Hv8Aglj+3B/wkFpB+zh8Urv/AE2BcaPcyn/WoP8AliSe4/h/Kvw3+Nfwc8afAb4j6j8MvHduYL7T5MBv4JYz9yRD3VhyK860jVtT0DVLfW9Gma2u7SRZYZYzhkdeQRX9V8Q5Hg+Ics9i2mpK8JLo7aNeXfyP4D4O4qzLg7PPrEYtOD5KlN6XSesX2a6dmf3v0V+fP/BPz9snTf2o/hsNK1+RIvFuhxql/D085OizoPQ9G9G+or9Bq/j/ADTLMRl2Kng8VG04O3+TXk+h/o5kOeYPOMBSzLAT5qU1deXdPs1s0Ffz9f8ABU/9uD7U8/7NvwsvPkX5dZuoj1/6YKR/49+Vfaf/AAUb/bTtP2b/AAEfA3gu4VvF+uRFYVBybWA8GVvQ9kFfyl3t7d6leS6hqEjTTzsXkkc5Zmbkkmv1/wAK+CPbzjnOOj7i/hp9X/N6Lp5+h/OXj34pfVKcuGsrn+8kv3sl9mL+wvNr4uy066Va/os/4IkwTL8OvGtwyERtqUIVscEiIZx9K/ED9nr4DeNf2j/ilp3wv8ER/vrtt09ww/d21uv35Xx2UdB3OAOtf2UfA/4LeCvgB8NdO+GPgODyrOwjAaQj55pT96Rz3Zjz7dBwK+n8XuIMNRy7+ylrVqWdv5Yp3u/W1kv8j4X6OnB+NxGcf2+1y4eipRv/ADSlG1l/hTu36L09br/M1/4PTf8Ak+z4d/8AYrv/AOjRX+mVX+Zr/wAHpv8AyfZ8O/8AsV3/APRor+aT+3z+nj/gn7+3N8Ev+Cd//Bu38J/2mfjnerBp+keG5VtLRWAnv7x7qcQ20K93kbj0UZJ4FfwheDfC37a//Byf/wAFOZ9S1Z5SdVnEt5OMmx8P6JG2FRew2r8qjq78+tfn1+0j+3N8bv2nvhJ8Kf2b/Gl0NL8F/CvShpukaejN5HmTyPJLeSjHzSNv25wdqDC9Tn/Vy/4IX/8ABO39mb9gX9iDw3F8A9VsfGN94zsrfWNW8WWWHj1WWZAymFuot0B2xLxgckbiaAPvX9iv9jn4MfsI/s8aB+zj8DNOSx0jRIFR5AoEtzPj55pT/E7nmv8AIo/4KN+DdN+In/BZz4j+AtZd47TWfHf2OZo/vBJnRDj3weK/2hK/xXf+ConjDVvh9/wV4+K3jrQY0lvdH8aSXkCSAlGkhZGUEDBxkdqAP7of+IMj/gnN/wBDb4q/7+x/4V+z3/BML/gkD+zt/wAEsPh14t+GPwYv9R1rTPGV0Lq+TVSsnSIRFQBxtKjkV/D4f+DxL/grDn/kQPBo/wC4Zff/ACVX9yf/AARg/bT+MH/BQP8A4J9eEP2o/jtp1jpXiTXZr+O4ttOikgt1W1uZIU2pKzsMqgJ+br0oA/zZv+C2v7FXjb/gkR/wVJfxl8KFl0/QNQ1BPFPhW6j+UIPM3tECO8b/ACn2r/S4/ZK/4KR/CL48f8E0tJ/4KCa9qENpo9r4ek1HXGJAFtc2MZ+0oR2wykgehFfDf/ByT/wTXj/4KA/sB6trXguxE/jz4dLJrWjFF/eTRxrme3H++g4HQEV/mefDj/gpb+0F8KP+CfXj3/gnHo8rJ4V8b6ta6hPIXKy2ywf66BV/uzlU8zpwmMc0AfTnwk8FfGH/AIL7/wDBZSWfVxN/xcPxBJqWpuORpugWhHy56DyrZUhTsXI9a/v9/wCDhn44a3/wTm/4I2XnhL9mwHw/9pbT/CFhJafuzaWciMG8sj7p2R7fxr41/wCDQ/8A4Jo/8M5fsmX/AO3J8S7DyfFvxZATSRKuJLbQLdv3ZHcfapQZD6xrERX77f8ABVL9gDw1/wAFLv2LfE/7LWu3o0y71AJd6VfMu5ba/t8mJmA528lWx2PtigD/ADev+Dd7/gjX8I/+Ct/xK8b6z+0P4jvbPRPCUcTyWljIFu7ue4PUu2SFHc4PNfdH/BX/AP4NRvib+z5qHh7xl/wTY07XPiFpGqSvb6hpDKJ7uxZV3JJvXG6NsbTwMHHrX5M69+zB/wAFov8Aggl8c7r4meGNF17wj9lYwnXtMg+36Hf26ngSOqvCUbrtk2uPQGv3F/Y2/wCD074t+Hbyy8NftxfDe016w+WObWPDT/ZrpR/eNrMSjnHpKnsKAP6Cf+DdfwD+3z4e/wCCf3iL9k//AIKH+GtZ8P3Hh65n0zQrnVgRPLo97DxGrNyfIcuq+ilR2r4/8Yf8Gcv/AATwWy1XxM3izxT5wSe5x5seN2C3p0r+nT9kb9rv4A/tyfAjRv2jf2bNei1/wxrSHZKgKSwTJxJBNGcNHLGeGRgCPoQa9x8af8ibq3/XlP8A+gGgD/FL/Yn/AGSPh5+0X/wUz8LfsdeMbq6t/DeteLn0Gae3IFwLdZ2jBB6bsCv9DT4B/wDBpT+wT+z18cPCHx48IeKPE02qeDNYstatI5pU8t5rGVZkVuPukqAfav4c/wDglP8A8p6Ph7/2UmT/ANK3r/YyoA/lS/4Oev8Agsn4p/4J4/BHSv2cP2e74WfxL+IdtLIbxP8AWaZpSkxmVfSSVgUjPbax9K/ko/4JAf8ABvd+0Z/wV7tbv9pz40eJ7jwv4Furp1Or3Km5v9TmU/vDCHPIB4LscZ6Vyv8Awdg+Ntf8Vf8ABZzx1o2rs32fQNL0SxslbosJsYZjt9jJK5+pr/TF/wCCZXw48JfCb9gD4R+A/BEEcGnWXhjTxGIwAGLRKS3HUk9TQB/K58Z/+DKL9n688Bzr8B/ipq1n4jijJg/tW2R7WVwOA+w7lB9gcV/LZ+zf+07+3f8A8G6//BQi88AeLVubddEvY4fEfh15CbDVtOcg+ZEPu5eP5opB0PB6EV/sP1/nI/8AB7l8OfCejftEfBD4oadFHHrGu6Hq1jeMoAaSHT5rdoc+u03Eg/GgD+yL9s340+BP2jP+CQPxF+O3wyulvdA8WfDu91SxmX+KG5tC659CAcEdjX+L94J8X+Kfh74v07x54KupbHVdGuI7u1uYSQ0UsRBVgR0wRX+lD/wSU8deIvGv/Bqb4sg8Qu0v9jeHPFun2zN/z7wy3GwfRQdo9hX8lv8Awbn/ALLPws/bT/bi1v8AZq+MVil7ovibwhq9uSw+aCbYPKmQ9mjbBGKAP9FP/ghV/wAFSvDP/BUH9jLTPGmo3EaePPC6R6Z4mswQGFwi4WcD+5MBnPrkV/LL/wAHw3/JXP2e/wDsE+If/RtlX4/fsr/Gr9oX/g25/wCCut/4G+J0U8mgWl4NO161XIi1PQrh/wB3cxDoWVcOh7OpXOM1+pv/AAeffETwX8XNd/Zh+KPw51CHVtA8Q+Hdb1DT7yA7o57a4exeN1PoVI+nSgD+kj/g2G/5QefD3/uOf+lk9f5ufwB/Z68H/tXf8FX9O/Zz8fzz2ujeL/HFxp13LakCZIpZ3yUzxmv9Iz/g2G/5QefD3/uOf+lk9f5kelfH/wAc/ssf8FC7v9ob4Z2tve694S8XXeoWMF0jSQvLFO+A6oVYj2BFAH+gZ/xBkf8ABOb/AKG3xV/39j/wr7P+FH/BtP8Asb/CLwBp/wAPPD/iTxDJZ6d5gjZ5U3fvZGkPb1av5S/+IxL/AIKw/wDQgeDf/BZe/wDyVX+gr/wTq/aC8d/tW/sOfC/9o74nWtvY+IPGWg22p39vaI0cEc0oOQiuWYL6Ak0Af//R/wA/+vpH9jqKKb9q/wCG8E6h0fxJpisrDIIM6DBHpXzdX0p+xr/ydp8NP+xm0v8A9KEoA/1I/wDgoZ/wTqm8FQzfHf4F2ZfSJFEupaZCv/HsSOZIlH8Hqo6duK/FCv737e3gutKjtrlBJHJEFZWGQQR0xX86H/BRv/gnVN4Amu/jt8DbMyaJIxl1LToVybUnrJGB/wAs/Ufw/Sv6E8OPEX2vJlWaz97aE317Rl59n123P478aPBj2HtM/wAgp/u96lNL4e84L+XvFbbrTbxj/gn1+3/rH7OesQ/DT4jzSXngu8kwuTubT3Y/eT/pmf4l7dR7/wBSOha7o/ifR7bxB4fuY7uyu41khmiIZHRuhBFfwS1+qP8AwT7/AOCgGr/s+avB8M/iTM914Pu3Cox5ayZv4l/2PUV3eIvh2sapZnlkf332or7Xmv735+p5fgx4yvK3DIs7n/s21Ob/AOXf91/3O38vpt/U/RWVomt6R4k0i317QbiO7s7uMSQyxHcjo3QgitWv5ucXF8rVrH9rQlGUVKL0P5m/+DtT/lD1r3/YxaV/KWv8muv9ZT/g7U/5Q9a9/wBjFpX8pa/ya6RR/XD/AMGaX/KT/X/+xNvv/RsNf6i9f5dH/Bml/wApP9f/AOxNvv8A0bDX+ovQB+en/BQX9jXTf2oPhwdZ8OxLF4t0SNnsZcYM0Y5MDex/h9DX8lWraTqWhancaLrELW11ayNFLE4wyOvBBFf3wV+FH/BU79h/+27Wf9pD4W2n+lwLnV7WJf8AWIP+Wygdx/F7V+1eFvG/1Wosnxsv3cvgf8r/AJfR9Oz9T+YvHrwt+v0ZcR5XD99BfvYpfFFfaX96K37x9D8Pfgl8ZfGvwD+JOm/E7wHP5N7p8mSh+5NEeHjcd1YcEV/U3rf/AAUM+DVj+yvH+0jp0yyyXKfZ4dLLDzv7RA5gYDsp5Lf3MEdRX8htT/ark2wsjI3kht4TPy7iMZx0zgV+s8U8D4HPKtCvX0lB62+1H+V/o+mp/PXAfipmvC2HxWFwlpQqL3U9oT2U18t1s7Lsd58Vfif4v+Mvj7UviP45uTdajqcpkdj0Ufwoo7Ko4AHQVy3hvw5rfi7XrTwx4btnu76+lWGCGMZZ3bgAVjAEkKoyTwAK/pI/4Jc/sQD4e6ND+0D8T7TGtX8edMt5RzbQt/GR2dh09BXXxLxBhOHst9s0tFywgtLu2iXkuvZHBwPwfmHGGd/V1J2b5qtR62V9X6vour8j7E/YT/ZC0T9lP4XLbXsaTeKNXVJdUugMkHHywqf7ifqefTH3HRRX8f5lmNfH4meLxMrzk7v/AC9Fsl0R/o7kmTYTKcDSy7Aw5aVNWS/X1e7fcK/zNf8Ag9N/5Ps+Hf8A2K7/APo0V/plV/FD/wAHKX/BE79uz/gpV+1N4P8Ain+y5pWmX2kaPobWNw97ei2YTGQNgLtORiuE9Q+C/jX/AMEN0/b3/wCCEPwL/bC/Zr0tP+FveDPCkv2u0gUBte0uC6uCYTjrcQjJgPVhmM9V2/Ln/BtJ/wAFz9Y/Yc+JEH7CX7Vt9Ivwy1+9MWl3V2SDoGoytgqd33beV/vr0R/m4y1f3x/8Emv2dfiX+yZ/wTp+FX7Ofxjght/E3hXSntL+K3k82JZGnlkAVsDI2sO1fyyf8F3/APg2A+JP7SP7Qw/aj/4J22WnW154pkeXxHotxMLOFLzr9pgO0geb/GoH3ue9AH90lleWmo2cWoWEizQTorxyIcqysMggjjBHSv8AGw/bfVG/4Lo+MVcAqfiNFkHp/ro6/wBGv/ghL8Nf+CpP7OPwIP7Mv/BRLSrK5s/DUSJ4e1u2vxdzNbDgW8w2g/IPut6cV/JP/wAFB/8Ag2g/4Ks/H39uf4lfHv4U6JozaL4i16bUNOmk1MRS+W2NpK7PlPFAH+k7/YPgz/nzsv8Av2n+FbdhDp1tALbTFjjiTosQAUfgOK/y3v8AiHB/4ODP+gnH/wCFJJ/hX9cH/BuF/wAE/wD9uj9gf4P/ABC8LftxXC3Gp65rEN1pxXUGv8QLAiHlgNvzA8UAf0kXFvBdQPa3KCSORSjKwyCpGCCPTFf4un/BRf4TfD/wr/wWO+Inwm8O6cln4f8A+E6EIs4vlRY7mSN5FHoCXbgdO1f7SNf5yP7bX/BuP/wU3+N3/BUfxf8AtS+A9D0aXwlq/iyHVraWXUQkptkMeSU2cH5TxmgD/RM8IeE/DngLwnpngbwfZx6fpGjWkNjZWsI2xwW9ugjjjUdlVVAA9BX59f8ABVH/AIKL6R/wS7/Zgb9qDxH4OvfGemw6lb6fcWtjOtu8IuA2JGZkcbRtx07iv0nrwj9pn9nD4VftbfAzxF+zz8atPXU/Dnia1a1uoT1Gfuup7MhwVPYigD8Yv+CTP/Bwb+zR/wAFbviB4g+DOl+GJfBGs6baLcQWWrXsVwdQiY7XESiOPJXuvPFfir/wd4fsL/8ABP74Wfs1aN+0h4F0PRvBvxYvNbgtYotJSO0fVraUN5xmgjwH8sDf5pXII255xX57ftU/8GjP/BQP9n34mzeNP2FfEtr4o0eOYyWLm6OnanbJ/CpI4YjpkYryn4ef8Guf/BZX9q74iWk37U2r2+h6dGVSbUtZ1Fr+eOPPPlxd+PcUAfqt/wAGP+q+P5Phz8etDumlPheHUtGmtVbPlC/kinWfb23GNIN3sFr+6Hxp/wAibq3/AF5T/wDoBr4g/wCCZ3/BOb4Jf8EwP2XNL/Zq+CyvcpFI15qmpzgfaNRv5QBJNJjpwoVVHCooA6V91eJbGfUvDl/ptqAZbi2ljQHgbmUgUAf49H/BKf8A5T0fD3/spMn/AKVvX+xlX+dJ+wb/AMG5/wDwUy+Av/BVbwj+1Z8QtE0aHwhpHjN9auJYtRDyi0M7SAiPYMnaRxmv9FugD/N9/wCDy/8AYO8ZeFP2kfDP7fXhaxkuPDfizToNF1ieNcrbalYgrEXI6CWDYF9429q/aX/g20/4Ldfs+/H79kvwv+yN8ePE1l4b+JPgW0TS4F1KZbePVLOEbYZIpHwpkC4DpnOegxX9On7Qn7Pfwi/am+EGtfAr456LBr3hnX4DBd2k65BHZlP8LqeVYcgjiv8APz/bo/4M4/2i/A3jS88afsA+KrXXtEkkaW30vVZTaXtsCeEWYAq+Og4BoA/0D/ij+0V8B/gn4MufiF8WfGGj+H9FtIjNJdXt5FFHsUZ+XLfNx0C5J7V/k7f8F+P+CkEf/BXX/goPYRfs+2lzqXhTw5HH4Z8KwpGTPqM08v7yZY+oM8hVUXrtReATge5eFv8Ag19/4LZfE/W4fC3jPT7fTtP3BXuNT1cvAi+oXnP04r+u/wD4I0/8GzXwF/4JxeJ7H9oT44X8XxA+KFoubKZotthpbsMFreM5zJjjzG5H8OKAPc/BX7G17+wT/wAG6evfsza6qDWdG+HWqT6ts+7/AGjexSXFyAe4WWRlB9BX8WH/AAaIf8pcLD/sXNU/9BWv9L/9uX4U+L/jl+xz8TPg58P445db8TeHL/TrFJW2I088RRAW7DJ61/G3/wAG+H/BBb/goX/wT2/4KB2n7QX7SGj6VZeG4tHvrNpLO+FxJ5s6gINgUccUAfp5/wAHPP8AwSFT9vf9l1v2i/g3pvnfFH4aW8lzAkCjzdT01Rumtjj7zKBvi/2ht4BNf5lPxQ/ag+L3xZ+B3w//AGePiJeG90b4XPqiaD5o/fW0GqvFJNBn/nmskW9F/hLN2OB/uyyxRzRNDMoZGG0qehB7V/ng/wDBY3/g1X/aY+Jf7aGtfGj/AIJ76ZpMvg7xlnU7vTrq6Fp/Z+oyMfPSNdpBikP7xcY2kkdMUAf0I/8ABsN/yg8+Hv8A3HP/AEsnr/Pn/wCCdEVvN/wXa8CRXSo8bfEeQFXAKkfaH6g8V/pff8EQv2OfjZ+xB/wTC8IfswfHq1trTxXpH9p/aIrWbzoh9quZZI8OAM/Kw7cV/Cb8T/8Ag1s/4LFar8b/ABD8SPBGjaLbC71e7vbOePVxFKqySsyEYTKnBoA/1Ff7B8F/8+dl/wB+0/wrbtm0+3gWC0MaRoMKqYCgDsAK/wAt7/iHB/4ODP8AoJx/+FJJ/hX63/sz/wDBF/8A4K8/D34IaH4P8eX4OrWYuPPxrTyD555HX5sc/KwoA//S/wA/+vpT9jX/AJO0+Gn/AGM2l/8ApQleO/8ACuviB/0A7/8A8BpP/ia+j/2PPAPjq2/av+G00+i3yIviXTCSbdwABcJ/s0Af7llh/wAeMP8A1zX+VSzwQXUD2tyiyRyKVZGGVKnggj0qKw/48Yf+ua/yq3QFuh/Nx/wUY/4J2TfDq5u/jj8ELMvoMrGTUNPiGTZseroP+eR9P4fpX4rV/fTc21te20lneRrLFKpR0cAqykYII6Yx2r+bf/gon/wTpvfhtd3Xxr+B9m8/h+ZjJfWEK7ms2PVkA6xf+g/Sv6G8OfEX23JlWaT9/aE317Rfn2fXbff+OPGjwY+rOpn+Q0/3e9Sml8P96C/l7r7O60284/4J8f8ABQTU/gBq8Hww+KM73Pg+7cKkjfM1i7fxD/pn6jt2r+oXSdW0zXtLt9a0WdLq0uo1lhliIZHRhkEEcYxX8GX9i6x/z6Tf9+z/AIV+sH/BPX9vHxR+z9qcHwp+LaXNx4Lun2wzsjM2mu38Q45hP8S/w9R3Fb+Ivh9DGKWZ5Yl7VfFBfa81/e8uvrvy+DHjDUy1wyLPZP6vtTqP/l3/AHZf3Oz+z/h22v8Ag7U/5Q9a9/2MWlfylr/Jrr/WV/4Os1k8W/8ABHTV5/C6NqCXOvaTLEbZTJvQiXBG3PFf5Tn/AArr4gf9AO//APAaT/4mv5zatoz+0E01dbH9V/8AwZpf8pP9f/7E2+/9Gw1/qL1/mD/8Gc3hTxPof/BTjXrnWdNubSM+Dr5Q00LIufNi4yQBX+nxSGFV7q1tr62ksryNZYpVKOjDIKnggirFFC02E0mrM/lS/wCCkn7FVz+z144b4k+BrYnwjrkxICDizuG5MZ9Fbqv5V+Xlf3a/Ev4b+EPi34H1H4eeOrRbzTNTiMMsZ6jPQqezKeQexFfzPaH/AMEufipL+1fJ8FtVSUeFbUi+fWguI5NPLfKFPTzmxsK9iCemK/pTgLxFoVsvnRzWpy1KMb3f2or85La3XTzP4l8WvBjF4bN6eJyCjzUcTLl5V/y7m+nlB7p7R1Wisbv/AATI/Ykk+NHilPjP8RbYjwzpEoNtE44u7hP/AGRO/qa/p7iijgiWGFQqIAqqOAAOgFcz4I8F+Gvh34UsfBXhC1Sy07ToVhgijGAqqMV1VfivF/FFfPMc8TPSC0hHsv8AN9f8kf074dcB4XhXKo4KlZ1XrUn/ADS/+RW0V2CiiivlT74K+d779qf4K6b+0rY/sj3eqFfHWpaVLrNvYeU2Gs4Thn342jHpmvoivwD8a2t0f+DjDwRdiJvKHww1Ib9vyg+YvGelAH6S/Cb/AIKF/sl/G3Wvih4b+HPimO+1H4OSzw+K7Xy2SWyNuHLtsIyyjy2AZeMjFcD45/4Kn/scfD79ljwz+2bretXs3w/8W4OnX9pp89wzLtZtzRRoXRQFOSwAFfyNaN+zx8cvh7/w1z/wUi/ZW0y71Pxj4K+J3jDQ/FOgKzKniDwbqFpEtwipj/XWTt9rhIH8LDngH99P+CXtvdr/AMG7HheCaF45W+GOqfuypDAm1n4xQB94fsrf8FUP2N/2zfCHiXx78BdavtQ0fwnZHUL+7uNPntYhbqCS0bSIokwFP3c1g/sif8Fc/wBif9uTx5F8O/2ctY1LVr2e2lu4pZdLuba1eKH7xWaRBGenABr42/4JcWd5D/wQC8O2U8LrN/wgupL5ZUhs+TLxivz/AP8Ag2T/AGjfB998LvBn7Pt3+0JceKNbtPD1yB8M5tB+xjRWjnZ2YX2wGXavOCf4vagD9e9e/wCC7f8AwTS8K/GTVfgd4n8bzafq2ha0/h7UbiewuE0+11CN/LMUl0U8lPm4yWxX2N8e/wBuv9l/9mX4hfD/AOGPxq8TQ6LqnxOuZLPw95ikw3MsYUlfMHypneoXJGScCv4Uvi74R/aEuPDv7Rum+NteOm/sx+L/ANpe/wBD+JVvZaUJtX0+1ke2ki1GOdztW2aRY4pCE3R9Rndiv22/4LRfsl/Dn9q79rv9jb9mm7M48N6rD4jtbS/tWbfaPDZQvaXCyL/FG6Iw55xQB/RP4e/as+CPin9pXXf2SNE1Uy+OvDWlW2s39j5bAR2d2cRPvxtOT2Brzzxz/wAFAv2Ufhv+1p4a/Yf8YeKIrT4k+LbY3Wm6WUY+ZGAxGXA2qW2NtBOTjiv5wv8Agjpr/wC01Yf8Fh/jbo37ZemtY+KvAfw80rQLvUwp8jU7fTZiIr1DgD97EAxxnmvyp/aHl/bL/aH8Y/GL/gq98LPgjq+vDw144sNb8I+N0v7SKPTNF8HSkTxJZtILuWK4Xex2RkH8CKAP7ef21/8Agoz+y1/wT603R9Z/ac1O90mz1tbhree1sJ7yNVtdm8yNCrCMDzFxuxnt0rlPhf8A8FTv2Ofi7+zT4r/a48Ja1fL4E8Fjdqd9d6fPbFF2o25I5EDOuHXBUEV82/8ABU74q+Hv2hf+CF/xP+NHgHdPpnjD4fJq1mAMt5V4kUqggd1DYI7EV5x+2faXcv8AwbweIrOOJ2mPwzsV8sKd2fLh4xQB+nnxU/bf/Zi+CX7PFl+1L8UvFFvo3gvUreG5tLycFWnW4AMaxx/eZ2HRAM15J+x1/wAFSf2Lv26fEWoeCvgB4nefX9Mi+0TaVqNrLp995H/PVYZ1R2j6fMBivxC/bH8F+K/CvwB/Yn/a28UeFtQ8Z/DL4UHT7/xbpdhatfS2sL2oVbxrVQTKsJ+8Np2jmuj8O/Hf4Vf8FTP+CvfwF/aI/wCCfun32peEfhJY60/jLxt/Z1xp1jLDe23lQaaJJo4jPJv6x4PljkdDgA/eT4aft5fst/Fv4+fED9mHwP4miuPHHwwEba/pbI0csCSLuDJkDzFAxkrkDIFd/wDs1ftQ/Bf9rf4P2vx3+Bmq/wBqeGLyW4hiumjaH57RzFL8rgEbWUiv48dd/Zq+NFx+3x+2V+3p+ypZzS/FT4OeN7K5hsMuIvEHh660uIajprKOGYqolhIyRIgABJFe+fsM/tLeJ/2XP+DZGT4l6Rp9xH4r1mTWdJ0awCETNqWrXssUUYBxgjccH2oA/pJ/ZQ/b+/ZU/ba1Xxfon7N3ieLxBc+Bb/8As3WI0RozDOCRgbgNy5UjcOK9D+H37VHwT+KHx48bfs1+DNUN14v+HkdlLrln5TKLdb9S8GGI2tuUdulfx3/8Es/Cf7Qf/BNf9vz4Q6V8Zfg5qnwr8MfFzw2PCOqX17qNnqEeq6/Hm5humFpI/kySMSreZtOOO1fdnwb/AGz/ANmr9kT/AILz/tPeHv2ifEqeGrz4gR+DdO8PpNbzSC9ufJKbEaONlHzSIPmIHNAH9Qvjbxfovw+8G6t488SM6adotnPfXTRoZHENuhdyqrySFU4Ar5Pl/wCChn7J0P7IK/t0v4mX/hWz2y3I1ERNu2s2wL5WN+/dxsxnNfaFzbW19ayWd2iywzIUdGGVZWGCCPQiv4StK+DvxcX9tCP/AIIItpN//wAK/wBO+JcnxDF9tb7N/wAIrxeRQ7umfPfBXpjj2oA/qi/aa/4Kr/sZ/si2Pgq8+Nut31k/xCsjf6Hb22nT3U9xAqqxPlxIWXCsOCK3viT/AMFNv2P/AIP/ALKGhftrfE7xBNofw98RXMNnaX15aSxSCWeR4kEkLKHjG6NuWAwBnpX4Of8ABfDxrpXwY/4KDfsseOrv4kS/BjS9IsNfiPiu30v+1Rp6tEqKn2baVYP9zpxmuu/4LGaz4J/ae/4JB/BHULXxQ/xY8PeJviL4OtbnXTZmwOrwNfNbzyNAoUw78MpAAx2oA/oW8Rfthfs/eGPi/wCA/gZqOuI3iH4l2k994dihQyR3dvbKHdxIvygbSCMnntXwp8XP+C7H/BO34HfGK++A3xE1/WLXxPYXT2bWkei3kvmSRHDeUVjIkUeq5Ffgx8GfhL+0X+yr/wAFvf2e/wBiH4mWtzq/gb4dWXiOfwF4lmLSNc+HdQQNBZzNjHm2JUwE8ZVV4xgn9df24rW6k/4LafspXMUTNEmla8GYL8o47noKAP1Q1b9s/wDZ+0L4q/Dn4Katq0lv4k+K1lPqHhy0eBwbiC2iE0hbjEZVCOGwe1S+Df2yf2fvHvxF+Kfwp8MawZ9b+DK2jeK4PJdfsYvrdrqHBIw+6FGb5emMV+Mn/BXvxjZfst/8FD/2Xv29/ixZX8Xws8Bf2/p3iLWbKzlvE0xtTt/LgknWBXZYs9XxgdPQV5z/AME09VuPj78Rv29f27vAum6hH8Nfi2dLTwlqV/aS2Z1SLRdGmtrieGOZUcw+YwCPtw31BAAP0V/Z7/4Li/8ABN/9pv4kaR8Kvhh42k/tbxBI8Ol/2hYz2UF7KmcxwSyoqO3B+VT2rvf2n/8Agrn+xJ+yF8af+GfPjNreoReLBaRXxsrDTLi+Zbeb7jkwowANfyAf8E9vBHxgv7/9ibwL+2f4lI+BuoNeax4M/s7Sxbvb+JbWVxHY310zMwUp86OoUPkLivvP/goX8btC/Z+/4Lw674y8W/HS4+Adjd+BNJgXVo9E/tldQKyZNrsKsE453CgD+lb9p7/go5+yf+x/8NPDPxR+OWvS6faeMhF/YtpDay3F/eGWMSgR20amUkIcsNvy965L4Y/8FZ/+CdvxZ8C6f8QvDXxV0O3stRVykV/cC0uYzG7RsskMm10YMpBVgDX5if8ABafUP2cT4Z+A37SHxJ8W+MvA13pE/wBp8P8AxV8N6UmoadorXkCkS6nbOCVguVx/BweCQK/B7wP+3B/wVB8SaE+s/DX9ijwf8d/D8t5fDTviEvgn7GPElslzIqX/AJJhypmUBjnqee9AH//Z';

// Format currency
const formatCurrency = (amount: number): string => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(amount);
};

// Format date (parse as local time to avoid timezone day-shift)
const formatDate = (dateStr: string): string => {
  // If date-only string (e.g., "2026-01-01"), parse as local time
  // new Date("2026-01-01") parses as UTC midnight, which shifts back a day in US timezones
  const parts = dateStr.split('T')[0].split('-').map(Number);
  const date = new Date(parts[0], parts[1] - 1, parts[2]);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
};

// Format month for display
const formatMonth = (monthStr: string): string => {
  // Parse the date string as local time to avoid timezone issues
  // monthStr is in format "2025-12-01"
  const [year, month] = monthStr.split('-').map(Number);
  const date = new Date(year, month - 1, 1); // month is 0-indexed
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
  });
};

// Filter transactions for statement display, matching finalize_statement logic.
// Platform uses parent order_payments (already_paid=false) as credits and parent refunds
// as debits, because receipt children are missing for historical orders.
// Non-platform uses child transactions (including already_paid).
// Both include pending withdrawals/payouts.
const filterStatementTransactions = (
  transactions: FinancialTransaction[],
  accountId: number,
  accountType: AccountType
): FinancialTransaction[] => {
  const isPlatform = accountType === 'platform';

  // Parents whose flows are already represented by child adjustment rows.
  // A parent refund is only shown when its children are missing (historical
  // orders), otherwise both would be counted in the running balance.
  const parentIdsWithChildren = new Set(
    transactions
      .filter((t) => t.parent_transaction_id !== null)
      .map((t) => t.parent_transaction_id)
  );

  return transactions.filter((t) => {
    const involvesAccount = t.account_from_id === accountId || t.account_to_id === accountId;
    if (!involvesAccount) return false;

    // Withdrawals/payouts (executed or pending) — always included
    if (
      (t.transaction_type === 'withdrawal' || t.transaction_type === 'payout') &&
      (t.status === 'executed' || t.status === 'pending')
    ) {
      return true;
    }

    // Parent dispute transactions — always included
    if (
      t.parent_transaction_id === null &&
      ['dispute', 'dispute_lost', 'dispute_won'].includes(t.transaction_type) &&
      t.status === 'executed'
    ) {
      return true;
    }

    if (isPlatform) {
      // Platform: parent order_payments TO platform (already_paid=false)
      if (
        t.parent_transaction_id === null &&
        t.transaction_type === 'order_payment' &&
        t.status === 'executed' &&
        t.already_paid === false
      ) {
        return true;
      }

      // Platform: parent refunds FROM platform (already_paid=false), but only
      // when no child adjustments exist — otherwise the refund would be
      // counted twice (parent + children)
      if (
        t.parent_transaction_id === null &&
        t.transaction_type === 'refund' &&
        t.status === 'executed' &&
        t.already_paid === false &&
        !parentIdsWithChildren.has(t.id)
      ) {
        return true;
      }

      // Platform: non-receipt, non-self child transactions (already_paid=false)
      if (
        t.parent_transaction_id !== null &&
        t.status === 'executed' &&
        t.already_paid === false &&
        t.account_from_id !== t.account_to_id && // exclude self-transfers
        t.transaction_type !== 'order_payment' // exclude receipt children
      ) {
        return true;
      }

      return false;
    }

    // Non-platform: child transactions (executed)
    if (t.parent_transaction_id !== null && t.status === 'executed') {
      return true;
    }

    return false;
  });
};

// Get account display name
const getAccountDisplayName = (
  account: { id: number; account_type: AccountType; reference: string | null; display_name?: string },
  associationNames: Record<number, string>,
  mcNames: Record<number, string>
): string => {
  if (account.display_name) return account.display_name;
  if (account.account_type === 'platform') return 'Platform';
  if (account.account_type === 'payment_gateway') return `Gateway: ${account.reference || 'Stripe'}`;
  if (account.account_type === 'association' && account.reference) {
    return associationNames[parseInt(account.reference)] || `Association ${account.reference}`;
  }
  if (account.account_type === 'management_company' && account.reference) {
    return mcNames[parseInt(account.reference)] || `MC ${account.reference}`;
  }
  return `Account ${account.id}`;
};

// Get effective transaction type (considering parent type for children)
const getEffectiveTransactionType = (
  transaction: FinancialTransaction,
  parentTypeMap?: Record<number, string>
): string => {
  // If this is a child transaction and we have parentTypeMap
  if (transaction.parent_transaction_id && parentTypeMap) {
    const parentType = parentTypeMap[transaction.parent_transaction_id];
    // For children of disputes/refunds/chargebacks, use the parent type
    if (parentType && ['dispute', 'refund', 'chargeback', 'dispute_won', 'dispute_lost', 'chargeback_reversal'].includes(parentType)) {
      return parentType;
    }
  }
  return transaction.transaction_type;
};

// Get descriptive transaction type label based on context
const getDescriptiveTypeLabel = (
  transaction: FinancialTransaction,
  accountId: number,
  accounts: Array<{ id: number; account_type: AccountType; reference: string | null; display_name?: string }>,
  parentTypeMap?: Record<number, string>
): string => {
  const effectiveType = getEffectiveTransactionType(transaction, parentTypeMap);
  const isChild = !!transaction.parent_transaction_id;

  // Get the 'to' account to determine if it's going to an association
  const toAccount = accounts.find(a => a.id === transaction.account_to_id);
  const fromAccount = accounts.find(a => a.id === transaction.account_from_id);

  // Determine if this is a distribution to an association
  const isToAssociation = toAccount?.account_type === 'association';
  const isFromPlatform = fromAccount?.account_type === 'platform';
  const isFromMC = fromAccount?.account_type === 'management_company';

  // For child transactions of order_payment going to associations
  if (isChild && effectiveType === 'order_payment') {
    if (isToAssociation) {
      return 'Association Dist.';
    }
    return 'Fee Dist.';
  }

  // For disputes
  if (effectiveType === 'dispute') {
    if (isChild) {
      return 'Dispute Adj.';
    }
    return 'Dispute';
  }

  // For refunds
  if (effectiveType === 'refund') {
    if (isChild) {
      return 'Refund Adj.';
    }
    return 'Refund';
  }

  // For chargebacks
  if (effectiveType === 'chargeback' || effectiveType === 'chargeback_reversal') {
    if (isChild) {
      return 'Chargeback Adj.';
    }
    return effectiveType === 'chargeback' ? 'Chargeback' : 'CB Reversal';
  }

  // For dispute won/lost
  if (effectiveType === 'dispute_won') {
    return isChild ? 'Dispute Won Adj.' : 'Dispute Won';
  }
  if (effectiveType === 'dispute_lost') {
    return isChild ? 'Dispute Lost Adj.' : 'Dispute Lost';
  }

  // Standard labels for non-child transactions
  const typeLabels: Record<string, string> = {
    order_payment: 'Payment',
    withdrawal: 'Withdrawal',
    manual_adjustment: 'Adjustment',
    fee_distribution: 'Fee Dist.',
    payout: 'Payout',
  };

  return typeLabels[effectiveType] || effectiveType;
};

// Get detailed transaction description based on type and context
const getDetailedDescription = (
  transaction: FinancialTransaction,
  accountId: number,
  accounts: Array<{ id: number; account_type: AccountType; reference: string | null; display_name?: string }>,
  associationNames: Record<number, string>,
  mcNames: Record<number, string>,
  parentTypeMap?: Record<number, string>
): string => {
  const effectiveType = getEffectiveTransactionType(transaction, parentTypeMap);
  const isChild = !!transaction.parent_transaction_id;
  const metadata = (transaction as any).metadata || {};

  // Get order reference
  const orderId = transaction.reference_type === 'order' ? transaction.reference_id : null;
  const orderStr = orderId ? `Order #${orderId}` : '';

  // Get dispute ID from metadata or provider_reference
  const disputeId = metadata.dispute_id ||
    (transaction.provider_reference?.startsWith('du_') ? transaction.provider_reference.split('_')[0] + '_' + transaction.provider_reference.split('_')[1] : null);

  // Get refund ID from provider_reference (pyr_xxx format)
  const refundId = transaction.provider_reference?.startsWith('pyr_')
    ? transaction.provider_reference.split('_').slice(0, 2).join('_')
    : null;

  // Get charge ID from metadata
  const chargeId = metadata.charge_id;

  // Get the embedded account objects from the transaction (these come from the API)
  // Fall back to searching in accounts array if embedded objects not available
  const txAny = transaction as any;
  const toAccount = txAny.account_to || accounts.find(a => a.id === transaction.account_to_id);
  const fromAccount = txAny.account_from || accounts.find(a => a.id === transaction.account_from_id);

  // Helper to get account name (short version for descriptions)
  const getAcctName = (acct: { id?: number; account_type?: string; reference?: string | null; display_name?: string } | null | undefined): string => {
    if (!acct) return '';
    if (acct.display_name) return acct.display_name;
    if (acct.account_type === 'association' && acct.reference) {
      return associationNames[parseInt(acct.reference)] || `Assoc. ${acct.reference}`;
    }
    if (acct.account_type === 'management_company' && acct.reference) {
      return mcNames[parseInt(acct.reference)] || `MC ${acct.reference}`;
    }
    if (acct.account_type === 'platform') return 'Platform';
    if (acct.account_type === 'payment_gateway') return 'Stripe';
    return '';
  };

  // Determine if this is a credit or debit for the current account
  const isCredit = transaction.account_to_id === accountId;
  const isDebit = transaction.account_from_id === accountId;

  // Get counterparty: if credit, show sender (from); if debit, show recipient (to)
  const counterparty = isCredit ? fromAccount : toAccount;
  const counterpartyName = getAcctName(counterparty);
  const directionPrefix = isCredit ? 'From' : 'To';

  // For order payment children - include order and counterparty
  if (isChild && effectiveType === 'order_payment') {
    if (counterpartyName && orderStr) {
      return `${orderStr} - ${directionPrefix}: ${counterpartyName}`.substring(0, 45);
    }
    if (counterpartyName) {
      return `${directionPrefix}: ${counterpartyName}`.substring(0, 45);
    }
    return orderStr || '';
  }

  // For disputes - include order, dispute number, and counterparty
  if (effectiveType === 'dispute' || effectiveType === 'dispute_won' || effectiveType === 'dispute_lost') {
    const parts: string[] = [];
    if (orderStr) parts.push(orderStr);
    if (counterpartyName) parts.push(`${directionPrefix}: ${counterpartyName}`);
    return parts.join(' - ').substring(0, 45) || '';
  }

  // For refunds - include order and counterparty
  if (effectiveType === 'refund') {
    const parts: string[] = [];
    if (orderStr) parts.push(orderStr);
    if (counterpartyName) parts.push(`${directionPrefix}: ${counterpartyName}`);
    return parts.join(' - ').substring(0, 45) || '';
  }

  // For chargebacks - include order and counterparty
  if (effectiveType === 'chargeback' || effectiveType === 'chargeback_reversal') {
    const parts: string[] = [];
    if (orderStr) parts.push(orderStr);
    if (counterpartyName) parts.push(`${directionPrefix}: ${counterpartyName}`);
    return parts.join(' - ').substring(0, 45) || '';
  }

  // For fee distributions - include order and counterparty
  if (effectiveType === 'fee_distribution') {
    const parts: string[] = [];
    if (orderStr) parts.push(orderStr);
    if (counterpartyName) parts.push(`${directionPrefix}: ${counterpartyName}`);
    return parts.join(' - ').substring(0, 45) || counterpartyName || '';
  }

  // For withdrawals and payouts - just show "Withdrawal" or "Payout" (no extra details needed)
  if (effectiveType === 'withdrawal' || effectiveType === 'payout') {
    return '';
  }

  // Default: use reference_type, reference_id, and counterparty
  if (transaction.reference_type && transaction.reference_id) {
    const refType = transaction.reference_type.charAt(0).toUpperCase() + transaction.reference_type.slice(1);
    if (counterpartyName) {
      return `${refType} #${transaction.reference_id} - ${directionPrefix}: ${counterpartyName}`.substring(0, 45);
    }
    return `${refType} #${transaction.reference_id}`;
  }
  if (counterpartyName) {
    return `${directionPrefix}: ${counterpartyName}`;
  }
  if (transaction.provider_reference) {
    return transaction.provider_reference.substring(0, 20);
  }
  return '';
};

// Get transaction description
const getTransactionDescription = (
  transaction: FinancialTransaction,
  associationNames: Record<number, string>,
  mcNames: Record<number, string>
): string => {
  const typeLabels: Record<string, string> = {
    order_payment: 'Order Payment',
    withdrawal: 'Withdrawal',
    refund: 'Refund',
    manual_adjustment: 'Manual Adjustment',
    fee_distribution: 'Fee Distribution',
    payout: 'Payout',
    dispute: 'Dispute',
    dispute_won: 'Dispute Won',
    dispute_lost: 'Dispute Lost',
    chargeback: 'Chargeback',
    chargeback_reversal: 'Chargeback Reversal',
  };

  let description = typeLabels[transaction.transaction_type] || transaction.transaction_type;

  if (transaction.reference_type && transaction.reference_id) {
    const refType = transaction.reference_type.charAt(0).toUpperCase() + transaction.reference_type.slice(1);
    description += ` - ${refType} #${transaction.reference_id}`;
  }

  return description;
};

export const generateStatementPDF = async (
  data: StatementExportData,
  accountId: number
): Promise<Blob> => {
  const { statement, accounts, snapshots, transactions, associationNames, mcNames, parentTypeMap } = data;

  // Find the account and snapshot
  const account = accounts.find((a) => a.id === accountId);
  const snapshot = snapshots.find((s) => s.account_id === accountId);

  if (!account || !snapshot) {
    throw new Error('Account or snapshot not found');
  }

  const accountName = getAccountDisplayName(account, associationNames, mcNames);

  // Filter transactions matching finalize_statement logic (platform-aware)
  const accountTransactions = filterStatementTransactions(transactions, accountId, account.account_type);

  // Initialize PDF
  const pdf = new jsPDF({
    orientation: 'portrait',
    unit: 'mm',
    format: 'a4',
  });

  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();
  const margin = 15;
  const contentWidth = pageWidth - 2 * margin;

  let yPos = margin;

  // Helper to check if we need a new page
  const checkNewPage = (requiredHeight: number) => {
    if (yPos + requiredHeight > pageHeight - margin) {
      pdf.addPage();
      yPos = margin;
      return true;
    }
    return false;
  };

  // Helper to draw a horizontal line
  const drawLine = (y: number, color = '#e5e7eb') => {
    pdf.setDrawColor(color);
    pdf.setLineWidth(0.3);
    pdf.line(margin, y, pageWidth - margin, y);
  };

  // ============== HEADER ==============

  // Statement title
  pdf.setTextColor('#111827');
  pdf.setFontSize(20);
  pdf.setFont('helvetica', 'bold');
  pdf.text('ACCOUNT STATEMENT', pageWidth - margin, yPos + 5, { align: 'right' });

  pdf.setFontSize(10);
  pdf.setFont('helvetica', 'normal');
  pdf.setTextColor('#6b7280');
  pdf.text(statement.statement_number, pageWidth - margin, yPos + 11, { align: 'right' });

  yPos += 20;

  // ============== ACCOUNT INFO BOX ==============

  // Draw info box background
  pdf.setFillColor('#f9fafb');
  pdf.roundedRect(margin, yPos, contentWidth, 35, 3, 3, 'F');

  // Account name and type
  pdf.setTextColor('#111827');
  pdf.setFontSize(14);
  pdf.setFont('helvetica', 'bold');
  pdf.text(accountName, margin + 5, yPos + 8);

  pdf.setFontSize(9);
  pdf.setFont('helvetica', 'normal');
  pdf.setTextColor('#6b7280');
  const accountTypeLabel =
    account.account_type === 'management_company'
      ? 'Management Company'
      : account.account_type === 'association'
      ? 'Association'
      : account.account_type.charAt(0).toUpperCase() + account.account_type.slice(1);
  pdf.text(`Account Type: ${accountTypeLabel}`, margin + 5, yPos + 14);
  pdf.text(`Account ID: ${account.id}`, margin + 5, yPos + 20);

  // Statement period info (right side)
  pdf.setTextColor('#111827');
  pdf.setFontSize(10);
  pdf.text('Statement Period:', pageWidth - margin - 5, yPos + 8, { align: 'right' });
  pdf.setFont('helvetica', 'bold');
  pdf.text(formatMonth(statement.statement_month), pageWidth - margin - 5, yPos + 14, {
    align: 'right',
  });

  pdf.setFont('helvetica', 'normal');
  pdf.text('Statement Date:', pageWidth - margin - 5, yPos + 22, { align: 'right' });
  pdf.setFont('helvetica', 'bold');
  pdf.text(formatDate(statement.statement_date), pageWidth - margin - 5, yPos + 28, {
    align: 'right',
  });

  yPos += 42;

  // ============== BALANCE SUMMARY ==============

  pdf.setFontSize(12);
  pdf.setFont('helvetica', 'bold');
  pdf.setTextColor('#111827');
  pdf.text('Balance Summary', margin, yPos);

  yPos += 8;

  // Balance summary table
  const balanceTableData = [
    ['Starting Balance', formatCurrency(snapshot.starting_balance)],
    ['Total Credits (+)', formatCurrency(snapshot.total_credits)],
    ['Total Debits (-)', formatCurrency(snapshot.total_debits)],
    ['Ending Balance', formatCurrency(snapshot.ending_balance)],
  ];

  // Draw balance table
  const colWidths = [contentWidth * 0.6, contentWidth * 0.4];
  const rowHeight = 8;

  balanceTableData.forEach((row, index) => {
    checkNewPage(rowHeight);

    const isLastRow = index === balanceTableData.length - 1;
    const isCredits = index === 1;
    const isDebits = index === 2;

    if (isLastRow) {
      pdf.setFillColor('#0d7377'); // Teal color for ending balance row
      pdf.rect(margin, yPos - 1, contentWidth, rowHeight + 2, 'F');
      pdf.setTextColor('#ffffff');
      pdf.setFont('helvetica', 'bold');
    } else {
      pdf.setFillColor(index % 2 === 0 ? '#f9fafb' : '#ffffff');
      pdf.rect(margin, yPos - 1, contentWidth, rowHeight + 2, 'F');
      pdf.setTextColor('#374151');
      pdf.setFont('helvetica', 'normal');
    }

    pdf.setFontSize(10);
    pdf.text(row[0], margin + 5, yPos + 5);

    // Color code the amounts
    if (!isLastRow) {
      if (isCredits) {
        pdf.setTextColor('#059669'); // Green for credits
      } else if (isDebits) {
        pdf.setTextColor('#dc2626'); // Red for debits
      }
    }
    pdf.text(row[1], pageWidth - margin - 5, yPos + 5, { align: 'right' });

    yPos += rowHeight + 2;
  });

  yPos += 10;

  // ============== TRANSACTIONS TABLE ==============

  pdf.setFontSize(12);
  pdf.setFont('helvetica', 'bold');
  pdf.setTextColor('#111827');
  pdf.text('Transaction Details', margin, yPos);

  yPos += 8;

  // Table header
  const headers = ['Date', 'Type', 'Description', 'Credit', 'Debit', 'Balance'];
  const transColWidths = [22, 25, 58, 22, 22, 25];

  pdf.setFillColor('#374151');
  pdf.rect(margin, yPos - 1, contentWidth, 8, 'F');
  pdf.setTextColor('#ffffff');
  pdf.setFontSize(8);
  pdf.setFont('helvetica', 'bold');

  let xPos = margin + 2;
  headers.forEach((header, i) => {
    pdf.text(header, xPos, yPos + 5);
    xPos += transColWidths[i];
  });

  yPos += 10;

  // Calculate running balance
  let runningBalance = snapshot.starting_balance;

  // Sort transactions by date
  const sortedTransactions = [...accountTransactions].sort(
    (a, b) => new Date(a.transaction_date).getTime() - new Date(b.transaction_date).getTime()
  );

  // Draw transaction rows
  sortedTransactions.forEach((transaction, index) => {
    const isCredit = transaction.account_to_id === accountId;
    const isDebit = transaction.account_from_id === accountId;

    // Update running balance
    if (isCredit && !isDebit) {
      runningBalance += transaction.amount;
    } else if (isDebit && !isCredit) {
      runningBalance -= transaction.amount;
    }
    // If both (self-transfer), no change

    checkNewPage(8);

    pdf.setFillColor(index % 2 === 0 ? '#f9fafb' : '#ffffff');
    pdf.rect(margin, yPos - 1, contentWidth, 8, 'F');

    pdf.setTextColor('#374151');
    pdf.setFontSize(7);
    pdf.setFont('helvetica', 'normal');

    xPos = margin + 2;

    // Date
    const txDate = new Date(transaction.transaction_date);
    pdf.text(txDate.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }), xPos, yPos + 5);
    xPos += transColWidths[0];

    // Type - use descriptive label that considers parent type and context
    const typeLabel = getDescriptiveTypeLabel(transaction, accountId, accounts, parentTypeMap);
    pdf.text(typeLabel, xPos, yPos + 5);
    xPos += transColWidths[1];

    // Description - use detailed description based on transaction type
    const desc = getDetailedDescription(transaction, accountId, accounts, associationNames, mcNames, parentTypeMap);
    pdf.text(desc, xPos, yPos + 5);
    xPos += transColWidths[2];

    // Credit
    if (isCredit && !isDebit) {
      pdf.setTextColor('#059669');
      pdf.text(formatCurrency(transaction.amount), xPos, yPos + 5);
    }
    xPos += transColWidths[3];

    // Debit
    if (isDebit && !isCredit) {
      pdf.setTextColor('#dc2626');
      pdf.text(formatCurrency(transaction.amount), xPos, yPos + 5);
    }
    xPos += transColWidths[4];

    // Balance
    pdf.setTextColor('#374151');
    pdf.text(formatCurrency(runningBalance), xPos, yPos + 5);

    yPos += 8;
  });

  // If no transactions
  if (sortedTransactions.length === 0) {
    checkNewPage(10);
    pdf.setTextColor('#6b7280');
    pdf.setFontSize(10);
    pdf.text('No transactions for this statement period.', margin + 5, yPos + 5);
    yPos += 15;
  }

  yPos += 10;

  // ============== FOOTER ==============

  checkNewPage(20);

  drawLine(yPos);
  yPos += 8;

  pdf.setFontSize(8);
  pdf.setTextColor('#9ca3af');
  pdf.setFont('helvetica', 'normal');
  pdf.text(
    `This statement was generated on ${formatDate(new Date().toISOString())}`,
    margin,
    yPos
  );
  pdf.text(
    'For questions, please contact finance@dommek.com',
    margin,
    yPos + 5
  );

  // Page numbers
  const totalPages = pdf.getNumberOfPages();
  for (let i = 1; i <= totalPages; i++) {
    pdf.setPage(i);
    pdf.setFontSize(8);
    pdf.setTextColor('#9ca3af');
    pdf.text(
      `Page ${i} of ${totalPages}`,
      pageWidth - margin,
      pageHeight - 10,
      { align: 'right' }
    );
  }

  return pdf.output('blob');
};

export const downloadStatementPDF = async (
  data: StatementExportData,
  accountId: number
): Promise<void> => {
  const blob = await generateStatementPDF(data, accountId);
  const account = data.accounts.find((a) => a.id === accountId);
  const accountName = account?.display_name || `account_${accountId}`;
  const filename = `statement_${data.statement.statement_number}_${accountName.replace(/\s+/g, '_')}.pdf`;

  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

export const downloadStatementCSV = (csvContent: string, statementNumber: string, accountName?: string): void => {
  const filename = accountName
    ? `statement_${statementNumber}_${accountName.replace(/\s+/g, '_')}.csv`
    : `statement_${statementNumber}_all_accounts.csv`;

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

// Format date in DD Month YYYY format (e.g., "31 December 2025")
const formatDateLong = (dateStr: string): string => {
  // Parse as local time to avoid timezone day-shift
  const parts = dateStr.split('T')[0].split('-').map(Number);
  const date = new Date(parts[0], parts[1] - 1, parts[2]);
  return date.toLocaleDateString('en-US', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
};

// Generate a combined PDF with all accounts
export const generateAllAccountsStatementPDF = async (
  data: StatementExportData
): Promise<Blob> => {
  const { statement, accounts, snapshots, transactions, associationNames, mcNames, parentTypeMap } = data;

  // Filter out payment gateway accounts
  const nonGatewayAccounts = accounts.filter((a) => a.account_type !== 'payment_gateway');

  if (nonGatewayAccounts.length === 0) {
    throw new Error('No accounts to export');
  }

  // Initialize PDF
  const pdf = new jsPDF({
    orientation: 'portrait',
    unit: 'mm',
    format: 'a4',
  });

  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();
  const margin = 15;
  const contentWidth = pageWidth - 2 * margin;

  // Keystone brand colors
  const tealColor = '#0d7377';
  const darkBlueColor = '#14274e';

  // Helper to draw a horizontal line
  const drawLine = (y: number, color = '#e5e7eb') => {
    pdf.setDrawColor(color);
    pdf.setLineWidth(0.3);
    pdf.line(margin, y, pageWidth - margin, y);
  };

  // ============== SUMMARY PAGE ==============
  let yPos = margin;

  // Company header
  pdf.setFontSize(12);
  pdf.setFont('helvetica', 'normal');
  pdf.setTextColor('#333333');
  pdf.text('Keystone International Ventures Pte. Ltd.', margin, yPos + 5);

  // Statement title (right side, teal color)
  pdf.setFontSize(28);
  pdf.setFont('helvetica', 'bold');
  pdf.setTextColor(tealColor);
  pdf.text('Statement', pageWidth - margin, yPos + 8, { align: 'right' });

  yPos += 15;

  // Draw KIV Logo from image
  const logoY = yPos;
  const logoWidth = 60;  // Width in mm
  const logoHeight = 10; // Height in mm (aspect ratio ~6:1 based on original 395x64)

  try {
    pdf.addImage(
      'data:image/jpeg;base64,' + KIV_LOGO_BASE64,
      'JPEG',
      margin,
      logoY,
      logoWidth,
      logoHeight
    );
  } catch (e) {
    // Fallback to text if image fails
    pdf.setFontSize(18);
    pdf.setFont('helvetica', 'bold');
    pdf.setTextColor('#000000');
    pdf.text('KEYSTONE INTERNATIONAL VENTURES', margin, logoY + 8);
  }

  // Statement info box (right side)
  const infoBoxX = pageWidth - margin - 65;
  pdf.setFontSize(9);
  pdf.setFont('helvetica', 'normal');
  pdf.setTextColor('#333333');
  pdf.text('Date:', infoBoxX, logoY + 4);
  pdf.text(formatDateLong(statement.statement_date), infoBoxX + 22, logoY + 4);

  pdf.text('Statement #', infoBoxX, logoY + 9);
  pdf.text(statement.statement_number, infoBoxX + 22, logoY + 9);

  pdf.text('Period:', infoBoxX, logoY + 14);
  pdf.text(formatMonth(statement.statement_month), infoBoxX + 22, logoY + 14);

  yPos += 22;

  // Calculate totals for summary
  let totalPlatform = 0;
  let totalManagementCompanies = 0;
  let totalAssociations = 0;
  let totalAllAccounts = 0;

  const accountSummaries: Array<{
    name: string;
    type: AccountType;
    startingBalance: number;
    totalCredits: number;
    totalDebits: number;
    endingBalance: number;
  }> = [];

  nonGatewayAccounts.forEach((account) => {
    const snapshot = snapshots.find((s) => s.account_id === account.id);
    if (!snapshot) return;

    const accountName = getAccountDisplayName(account, associationNames, mcNames);
    const endingBalance = snapshot.ending_balance;

    accountSummaries.push({
      name: accountName,
      type: account.account_type,
      startingBalance: snapshot.starting_balance,
      totalCredits: snapshot.total_credits,
      totalDebits: snapshot.total_debits,
      endingBalance: endingBalance,
    });

    totalAllAccounts += endingBalance;

    if (account.account_type === 'platform') {
      totalPlatform += endingBalance;
    } else if (account.account_type === 'management_company') {
      totalManagementCompanies += endingBalance;
    } else if (account.account_type === 'association') {
      totalAssociations += endingBalance;
    }
  });

  // Sort summaries: Platform first, then Management Companies, then Associations alphabetically
  // Note: Filtering of empty accounts is handled by the caller via the includeEmptyAccounts option
  accountSummaries.sort((a, b) => {
    const typeOrder: Record<AccountType, number> = {
      platform: 0,
      management_company: 1,
      association: 2,
      payment_gateway: 3,
    };
    if (typeOrder[a.type] !== typeOrder[b.type]) {
      return typeOrder[a.type] - typeOrder[b.type];
    }
    return a.name.localeCompare(b.name);
  });

  // Account Summary box - simple list format like the reference
  // Summary rows with alternating background
  const hasPlatformAccount = data.accounts.some((a) => a.account_type === 'platform');
  const summaryData = [
    ...(hasPlatformAccount ? [['Platform Balance', formatCurrency(totalPlatform)]] : []),
    ['Management Companies Balance', formatCurrency(totalManagementCompanies)],
    ['Associations Balance', formatCurrency(totalAssociations)],
    ['Total All Accounts', formatCurrency(totalAllAccounts)],
  ];

  summaryData.forEach((row, index) => {
    const isLastRow = index === summaryData.length - 1;
    pdf.setFillColor(index % 2 === 0 ? '#f5f5f5' : '#ffffff');
    pdf.rect(margin, yPos, contentWidth, 8, 'F');

    pdf.setTextColor('#333333');
    pdf.setFontSize(10);
    pdf.setFont('helvetica', isLastRow ? 'bold' : 'normal');
    pdf.text(row[0], margin + 5, yPos + 5.5);
    pdf.text(row[1], pageWidth - margin - 5, yPos + 5.5, { align: 'right' });

    yPos += 8;
  });

  yPos += 15;

  // Accounts Detail Table Header - teal background
  pdf.setFillColor(tealColor);
  pdf.rect(margin, yPos, contentWidth, 9, 'F');
  pdf.setTextColor('#ffffff');
  pdf.setFontSize(9);
  pdf.setFont('helvetica', 'bold');

  // Column positions (total width = contentWidth = 180mm)
  // Adjusted widths to ensure all columns fit
  const col1Width = 68;  // Account Name
  const col2Width = 26;  // Starting Bal.
  const col3Width = 26;  // Credits
  const col4Width = 26;  // Debits
  const col5Width = 26;  // Ending Bal.

  const col1X = margin + 2;
  const col2X = margin + col1Width;
  const col3X = col2X + col2Width;
  const col4X = col3X + col3Width;
  const col5X = col4X + col4Width;

  pdf.text('Account Name', col1X, yPos + 6);
  pdf.text('Starting Bal.', col2X + col2Width - 2, yPos + 6, { align: 'right' });
  pdf.text('Credits', col3X + col3Width - 2, yPos + 6, { align: 'right' });
  pdf.text('Debits', col4X + col4Width - 2, yPos + 6, { align: 'right' });
  pdf.text('Ending Bal.', col5X + col5Width - 2, yPos + 6, { align: 'right' });

  yPos += 11;

  // Helper function to draw table header on new page
  const drawTableHeader = () => {
    pdf.setFillColor(tealColor);
    pdf.rect(margin, yPos, contentWidth, 9, 'F');
    pdf.setTextColor('#ffffff');
    pdf.setFontSize(9);
    pdf.setFont('helvetica', 'bold');
    pdf.text('Account Name', col1X, yPos + 6);
    pdf.text('Starting Bal.', col2X + col2Width - 2, yPos + 6, { align: 'right' });
    pdf.text('Credits', col3X + col3Width - 2, yPos + 6, { align: 'right' });
    pdf.text('Debits', col4X + col4Width - 2, yPos + 6, { align: 'right' });
    pdf.text('Ending Bal.', col5X + col5Width - 2, yPos + 6, { align: 'right' });
    yPos += 11;
  };

  // Account rows
  let currentType: AccountType | null = null;
  let rowIndex = 0;

  accountSummaries.forEach((summary) => {
    // Check if we need a new page
    if (yPos > pageHeight - 25) {
      pdf.addPage();
      yPos = margin;
      drawTableHeader();
    }

    // Add section header if type changes
    if (summary.type !== currentType) {
      currentType = summary.type;
      const sectionLabel =
        summary.type === 'platform'
          ? 'Platform'
          : summary.type === 'management_company'
          ? 'Management Companies'
          : 'Associations';

      pdf.setFillColor(darkBlueColor);
      pdf.rect(margin, yPos, contentWidth, 8, 'F');
      pdf.setTextColor('#ffffff');
      pdf.setFontSize(9);
      pdf.setFont('helvetica', 'bold');
      pdf.text(sectionLabel, margin + 3, yPos + 5.5);
      yPos += 9;
      rowIndex = 0; // Reset row index for alternating colors within section
    }

    // Account row with alternating background
    pdf.setFillColor(rowIndex % 2 === 0 ? '#ffffff' : '#f9f9f9');
    pdf.rect(margin, yPos, contentWidth, 8, 'F');

    pdf.setFontSize(8);
    pdf.setFont('helvetica', 'normal');

    // Truncate long names (shorter to fit narrower column)
    const maxNameLength = 38;
    const displayName = summary.name.length > maxNameLength
      ? summary.name.substring(0, maxNameLength - 3) + '...'
      : summary.name;

    pdf.setTextColor('#333333');
    pdf.text(displayName, col1X, yPos + 5.5);

    pdf.setTextColor('#333333');
    pdf.text(formatCurrency(summary.startingBalance), col2X + col2Width - 2, yPos + 5.5, { align: 'right' });

    pdf.setTextColor('#059669'); // Green for credits
    pdf.text(formatCurrency(summary.totalCredits), col3X + col3Width - 2, yPos + 5.5, { align: 'right' });

    pdf.setTextColor('#dc2626'); // Red for debits
    pdf.text(formatCurrency(summary.totalDebits), col4X + col4Width - 2, yPos + 5.5, { align: 'right' });

    pdf.setTextColor('#333333');
    pdf.setFont('helvetica', 'bold');
    pdf.text(formatCurrency(summary.endingBalance), col5X + col5Width - 2, yPos + 5.5, { align: 'right' });

    yPos += 8;
    rowIndex++;
  });

  // Totals row - teal background
  yPos += 2;
  pdf.setFillColor(tealColor);
  pdf.rect(margin, yPos, contentWidth, 9, 'F');
  pdf.setTextColor('#ffffff');
  pdf.setFontSize(9);
  pdf.setFont('helvetica', 'bold');

  pdf.text('TOTAL', col1X, yPos + 6);

  // Use accountSummaries for totals (only accounts shown in table)
  const totalStarting = accountSummaries.reduce((sum, a) => sum + a.startingBalance, 0);
  const totalCredits = accountSummaries.reduce((sum, a) => sum + a.totalCredits, 0);
  const totalDebits = accountSummaries.reduce((sum, a) => sum + a.totalDebits, 0);
  const totalEnding = accountSummaries.reduce((sum, a) => sum + a.endingBalance, 0);

  pdf.text(formatCurrency(totalStarting), col2X + col2Width - 2, yPos + 6, { align: 'right' });
  pdf.text(formatCurrency(totalCredits), col3X + col3Width - 2, yPos + 6, { align: 'right' });
  pdf.text(formatCurrency(totalDebits), col4X + col4Width - 2, yPos + 6, { align: 'right' });
  pdf.text(formatCurrency(totalEnding), col5X + col5Width - 2, yPos + 6, { align: 'right' });

  yPos += 20;

  // Footer on summary page
  pdf.setFontSize(11);
  pdf.setFont('helvetica', 'bold');
  pdf.setTextColor('#333333');
  pdf.text('Thank you for your business!', pageWidth / 2, yPos, { align: 'center' });

  yPos += 8;
  pdf.setFontSize(8);
  pdf.setFont('helvetica', 'normal');
  pdf.setTextColor('#666666');
  pdf.text('7030 ANG MO KIO AVENUE 5 #09-46 NORTHSTAR @ AMK Singapore 569880', pageWidth / 2, yPos, { align: 'center' });

  // ============== INDIVIDUAL ACCOUNT PAGES ==============

  // Process each account
  nonGatewayAccounts.forEach((account, accountIndex) => {
    const snapshot = snapshots.find((s) => s.account_id === account.id);
    if (!snapshot) return;

    const accountName = getAccountDisplayName(account, associationNames, mcNames);

    // Filter transactions matching finalize_statement logic (platform-aware)
    const accountTransactions = filterStatementTransactions(transactions, account.id, account.account_type);

    // Add new page for each account (all accounts start on new page since summary is page 1)
    pdf.addPage();

    let yPos = margin;

    // Helper to check if we need a new page
    const checkNewPage = (requiredHeight: number) => {
      if (yPos + requiredHeight > pageHeight - margin) {
        pdf.addPage();
        yPos = margin;
        return true;
      }
      return false;
    };

    // ============== KIV LOGO ==============
    const logoWidth = 50;
    const logoHeight = 8;
    try {
      pdf.addImage(
        'data:image/jpeg;base64,' + KIV_LOGO_BASE64,
        'JPEG',
        margin,
        yPos,
        logoWidth,
        logoHeight
      );
    } catch (e) {
      // Fallback to text if image fails
      pdf.setFontSize(14);
      pdf.setFont('helvetica', 'bold');
      pdf.setTextColor('#000000');
      pdf.text('KEYSTONE INTERNATIONAL VENTURES', margin, yPos + 6);
    }

    // ============== HEADER ==============

    // Statement title (on same line as logo, right-aligned)
    pdf.setTextColor('#111827');
    pdf.setFontSize(20);
    pdf.setFont('helvetica', 'bold');
    pdf.text('ACCOUNT STATEMENT', pageWidth - margin, yPos + 5, { align: 'right' });

    pdf.setFontSize(10);
    pdf.setFont('helvetica', 'normal');
    pdf.setTextColor('#6b7280');
    pdf.text(statement.statement_number, pageWidth - margin, yPos + 11, { align: 'right' });

    yPos += 20;

    // ============== ACCOUNT INFO BOX ==============

    // Calculate box height based on account name length
    pdf.setFontSize(14);
    pdf.setFont('helvetica', 'bold');
    const maxNameWidth = contentWidth - 70; // Leave space for right side info
    const nameLines = pdf.splitTextToSize(accountName, maxNameWidth);
    const nameHeight = nameLines.length * 6; // ~6mm per line
    const boxHeight = Math.max(35, 20 + nameHeight); // Minimum 35mm, or expand for long names

    pdf.setFillColor('#f9fafb');
    pdf.roundedRect(margin, yPos, contentWidth, boxHeight, 3, 3, 'F');

    pdf.setTextColor('#111827');
    pdf.text(nameLines, margin + 5, yPos + 8);

    pdf.setFontSize(9);
    pdf.setFont('helvetica', 'normal');
    pdf.setTextColor('#6b7280');
    const accountTypeLabel =
      account.account_type === 'management_company'
        ? 'Management Company'
        : account.account_type === 'association'
        ? 'Association'
        : account.account_type.charAt(0).toUpperCase() + account.account_type.slice(1);
    const typeY = yPos + 8 + nameHeight + 2;
    pdf.text(`Account Type: ${accountTypeLabel}`, margin + 5, typeY);
    pdf.text(`Account ID: ${account.id}`, margin + 5, typeY + 6);

    pdf.setTextColor('#111827');
    pdf.setFontSize(10);
    pdf.text('Statement Period:', pageWidth - margin - 5, yPos + 8, { align: 'right' });
    pdf.setFont('helvetica', 'bold');
    pdf.text(formatMonth(statement.statement_month), pageWidth - margin - 5, yPos + 14, {
      align: 'right',
    });

    pdf.setFont('helvetica', 'normal');
    pdf.text('Statement Date:', pageWidth - margin - 5, yPos + 22, { align: 'right' });
    pdf.setFont('helvetica', 'bold');
    pdf.text(formatDate(statement.statement_date), pageWidth - margin - 5, yPos + 28, {
      align: 'right',
    });

    yPos += boxHeight + 7;

    // ============== BALANCE SUMMARY ==============

    pdf.setFontSize(12);
    pdf.setFont('helvetica', 'bold');
    pdf.setTextColor('#111827');
    pdf.text('Balance Summary', margin, yPos);

    yPos += 8;

    const balanceTableData = [
      ['Starting Balance', formatCurrency(snapshot.starting_balance)],
      ['Total Credits (+)', formatCurrency(snapshot.total_credits)],
      ['Total Debits (-)', formatCurrency(snapshot.total_debits)],
      ['Ending Balance', formatCurrency(snapshot.ending_balance)],
    ];

    const rowHeight = 8;

    balanceTableData.forEach((row, index) => {
      checkNewPage(rowHeight);

      const isLastRow = index === balanceTableData.length - 1;
      const isCredits = index === 1;
      const isDebits = index === 2;

      if (isLastRow) {
        pdf.setFillColor(tealColor); // Teal color for ending balance row
        pdf.rect(margin, yPos - 1, contentWidth, rowHeight + 2, 'F');
        pdf.setTextColor('#ffffff');
        pdf.setFont('helvetica', 'bold');
      } else {
        pdf.setFillColor(index % 2 === 0 ? '#f9fafb' : '#ffffff');
        pdf.rect(margin, yPos - 1, contentWidth, rowHeight + 2, 'F');
        pdf.setTextColor('#374151');
        pdf.setFont('helvetica', 'normal');
      }

      pdf.setFontSize(10);
      pdf.text(row[0], margin + 5, yPos + 5);

      if (!isLastRow) {
        if (isCredits) {
          pdf.setTextColor('#059669');
        } else if (isDebits) {
          pdf.setTextColor('#dc2626');
        }
      }
      pdf.text(row[1], pageWidth - margin - 5, yPos + 5, { align: 'right' });

      yPos += rowHeight + 2;
    });

    yPos += 10;

    // ============== TRANSACTIONS TABLE ==============

    pdf.setFontSize(12);
    pdf.setFont('helvetica', 'bold');
    pdf.setTextColor('#111827');
    pdf.text('Transaction Details', margin, yPos);

    yPos += 8;

    const headers = ['Date', 'Type', 'Description', 'Credit', 'Debit', 'Balance'];
    const transColWidths = [22, 25, 58, 22, 22, 25];

    pdf.setFillColor('#374151');
    pdf.rect(margin, yPos - 1, contentWidth, 8, 'F');
    pdf.setTextColor('#ffffff');
    pdf.setFontSize(8);
    pdf.setFont('helvetica', 'bold');

    let xPos = margin + 2;
    headers.forEach((header, i) => {
      pdf.text(header, xPos, yPos + 5);
      xPos += transColWidths[i];
    });

    yPos += 10;

    let runningBalance = snapshot.starting_balance;

    const sortedTransactions = [...accountTransactions].sort(
      (a, b) => new Date(a.transaction_date).getTime() - new Date(b.transaction_date).getTime()
    );

    sortedTransactions.forEach((transaction, index) => {
      const isCredit = transaction.account_to_id === account.id;
      const isDebit = transaction.account_from_id === account.id;

      if (isCredit && !isDebit) {
        runningBalance += transaction.amount;
      } else if (isDebit && !isCredit) {
        runningBalance -= transaction.amount;
      }

      checkNewPage(8);

      pdf.setFillColor(index % 2 === 0 ? '#f9fafb' : '#ffffff');
      pdf.rect(margin, yPos - 1, contentWidth, 8, 'F');

      pdf.setTextColor('#374151');
      pdf.setFontSize(7);
      pdf.setFont('helvetica', 'normal');

      xPos = margin + 2;

      const txDateParts = String(transaction.transaction_date).split('T')[0].split('-').map(Number);
      const txDate = new Date(txDateParts[0], txDateParts[1] - 1, txDateParts[2]);
      pdf.text(txDate.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }), xPos, yPos + 5);
      xPos += transColWidths[0];

      // Type - use descriptive label that considers parent type and context
      const typeLabel = getDescriptiveTypeLabel(transaction, account.id, accounts, parentTypeMap);
      pdf.text(typeLabel, xPos, yPos + 5);
      xPos += transColWidths[1];

      // Description - use detailed description based on transaction type
      const desc = getDetailedDescription(transaction, account.id, accounts, associationNames, mcNames, parentTypeMap);
      pdf.text(desc, xPos, yPos + 5);
      xPos += transColWidths[2];

      if (isCredit && !isDebit) {
        pdf.setTextColor('#059669');
        pdf.text(formatCurrency(transaction.amount), xPos, yPos + 5);
      }
      xPos += transColWidths[3];

      if (isDebit && !isCredit) {
        pdf.setTextColor('#dc2626');
        pdf.text(formatCurrency(transaction.amount), xPos, yPos + 5);
      }
      xPos += transColWidths[4];

      pdf.setTextColor('#374151');
      pdf.text(formatCurrency(runningBalance), xPos, yPos + 5);

      yPos += 8;
    });

    if (sortedTransactions.length === 0) {
      checkNewPage(10);
      pdf.setTextColor('#6b7280');
      pdf.setFontSize(10);
      pdf.text('No transactions for this statement period.', margin + 5, yPos + 5);
      yPos += 15;
    }

    yPos += 10;

    // ============== FOOTER ==============

    checkNewPage(20);

    drawLine(yPos);
    yPos += 8;

    pdf.setFontSize(8);
    pdf.setTextColor('#9ca3af');
    pdf.setFont('helvetica', 'normal');
    pdf.text(
      `This statement was generated on ${formatDate(new Date().toISOString())}`,
      margin,
      yPos
    );
    pdf.text(
      'For questions, please contact finance@dommek.com',
      margin,
      yPos + 5
    );
  });

  // Page numbers
  const totalPages = pdf.getNumberOfPages();
  for (let i = 1; i <= totalPages; i++) {
    pdf.setPage(i);
    pdf.setFontSize(8);
    pdf.setTextColor('#9ca3af');
    pdf.text(
      `Page ${i} of ${totalPages}`,
      pageWidth - margin,
      pageHeight - 10,
      { align: 'right' }
    );
  }

  return pdf.output('blob');
};

// Download combined PDF for all accounts
export const downloadAllAccountsStatementPDF = async (
  data: StatementExportData
): Promise<void> => {
  const blob = await generateAllAccountsStatementPDF(data);
  const filename = `statement_${data.statement.statement_number}_all_accounts.pdf`;

  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
